import React from 'react';
import ReactEcharts from 'echarts-for-react'

const LineChart = (props) => {
  let { views } = props
  let timeData = views.map(item=>{
    return item.countDate
  })
  let LineData = views.map(item=>{
    return item.count
  })
  const styleClass = {
    height: '350px',
    width: '100%',
    backgroundColor: '#fff'
  }

  let option = {
    xAxis: {
      data: timeData,
      // boundaryGap: false,
      axisTick: {
        show: false
      },
      axisLabel:{
        interval:0
      }
    },
    grid: {
      left: 10,
      right: 10,
      bottom: 20,
      top: 30,
      containLabel: true
    },
    tooltip: {
      trigger: 'axis',
      axisPointer: {
        type: 'cross'
      },
      padding: [5, 10]
    },
    yAxis: {
      axisTick: {
        show: false
      }
    },
    legend: {
      data: ['网站近七日访问量']
    },
    series: [{
      name: '网站近七日访问量', itemStyle: {
        normal: {
          color: '#FF005A',
          lineStyle: {
            color: '#FF005A',
            width: 2
          }
        }
      },
      smooth: true,
      type: 'line',
      data: LineData,
      animationDuration: 2800,
      animationEasing: 'cubicInOut'
    }
    ]
  }
  return (
    <ReactEcharts option={option} className='echarts-for-echarts lineChart' style={styleClass}></ReactEcharts>
  );
};

export default LineChart;